/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/


import React from 'react';
import { Grid, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Link } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import SideBar from './SideBar';
import { BrowserView, MobileView } from 'react-device-detect';

import UserAvatar from "../../components/shared/Buttons/UserAvatar";
import { useSelector } from 'react-redux';


const PageHeader = () => {
  const { classes } = useStyles();
  const loginned = useSelector(state => state.user.loginned);
  const user = useSelector(state => state.user.user);

  return (
    <div className={classes.root}>

      <Grid container >

        <AppBar
          position="static"
          elevation={0}
          className={classes.appBar}
        >
          <Toolbar className={classes.toolbar}>
            <a
              href={"/dashboard"}
            >
              <img src="/assets/images/logo/logo.png" height="70px" alt="" />
            </a>
            <BrowserView>
              <Typography variant="h3" className={classes.toolbarTitle}>
                Pet-Scape
              </Typography>
            </BrowserView>

            {loginned === true ?
              <UserAvatar user={user} /> : (

                <div className={classes.headerMenu}>

                  <MobileView>
                    <SideBar />
                  </MobileView>
                </div>)}
          </Toolbar>
        </AppBar>
      </Grid>
    </div>
  );

}

const useStyles = makeStyles({ "name": { PageHeader } })(theme => ({
  root: {
    position: "relative",
    background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%,  ${theme.palette.secondary.main}  35%, ${theme.palette.primary.main}  100%)!important`,


  },

  appBar: {
    width: '100%',
    borderBottom: `1px solid grey`

  },
  toolbar: {
    flexWrap: 'wrap'
  },
  toolbarTitle: {
    color: "white",
    background: 'transparent',
    fontSize: 30,
    marginLeft: 10,
    fontFamily: "sans-serif"
  },
  headerMenu: {
    marginLeft: "auto",
    display: "inline-block",
    textAlign: "right",
    marginTop: "10px",
    color: "white",
    "&:hover": {
      color: theme.palette.secondary.main
    }
  },
  linkBar: {
    marginLeft: "30px",
    textAlign: "right",
    marginRight: "30px",
    paddingTop: "30px"
  },
}));

export default PageHeader;

